
import { defineComponent } from 'vue'
import QuillRichText from '../shared/QuillRichText.vue'

export default defineComponent({
  name: 'OrderDetail',
  props: ['documents'],
  components : {
    QuillRichText
  },
  data () {
    return {
      admissionDate: new Date().toISOString().substr(0, 10),
      documentTypeItems: ['Note', 'Discharge Summary', 'Medical Certificate', 'Other']
    }
  },
  computed: {
    document: {
      get () {
        return this.documents
      },
      set (value) {
        this.$emit('updateDocument', value)
      }
    }
  },
  methods: {
    updateDocumentContent(value) {
      console.log('test amy value:', value)
    }
  }

})
